<template lang="pug">
	.progress
		Flag.progress__icon
		.progress__content
			.progress__header
				.progress__title {{title}}
				.progress__present {{setWidth}}

			.progress__bar
				.progress__line(
					:style="{width: setWidth}"
				)


</template>

<script>
import Flag from './icon/Flag';
export default {
  components: { Flag },
  props: {
    lineWidth: {},
    title: {
      type: String,
      default: 'Курс пройден на '
    }
  },
  computed: {
    setWidth() {
      let currentWidth;

      if (this.lineWidth > 100) {
        currentWidth = 100;
      } else if (this.lineWidth < 0) {
        currentWidth = 0;
      } else {
        currentWidth = this.lineWidth;
      }

      return `${currentWidth}%`;
    }
  }
};
</script>
